<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { C_ANSWER_TEMPLATE_INTERPOLATION_CODES } from 'src/store/modules/app';
import { parseAnswerTemplateForReplacement } from 'src/utils';

export default {
  name: 'answer-templates',
  props: ['value'],
  async mounted() {
    await this.loadAnswerTemplates();
  },
  data() {
    return {
      header: this.value.header,
      templateAnswerSelect: null,
      templateAnswerText: null,
    };
  },
  methods: {
    ...mapActions('operatorChat', ['loadAnswerTemplates']),
    closeAnswerTemplates() {
      this.templateAnswerSelect = null;
      this.templateAnswerText = null;
    },
    close() {
      this.$parent.close([null]);
    },
    resolve(answer) {
      if (answer) {
        const parsedTemplate = parseAnswerTemplateForReplacement({
          template: this.templateAnswerTextEditor,
          customer: this.currentActivity.customer,
          isExternalOperator: this.isExternalOperator,
          interpolationCodes: this.$store.state.app[C_ANSWER_TEMPLATE_INTERPOLATION_CODES],
        });
        this.value.onGeneterateTemplate(parsedTemplate);
        this.close();
      } else {
        this.close();
      }
      this.closeAnswerTemplates();
    },
  },
  computed: {
    ...mapState('operatorChat', ['answerTemplates']),
    ...mapState('app', ['mode', 'isFrame']),
    ...mapState('home', ['ucceIntegration']),
    ...mapGetters('activities', ['getActivityById']),
    ...mapGetters('user', ['isExternalOperator']),
    defaultAnswerTemplates() {
      return this.answerTemplates;
    },
    templateAnswerTextEditor: {
      get() {
        if (this.templateAnswerText !== this.templateAnswerSelect) {
          return this.templateAnswerText;
        }
        return this.templateAnswerSelect;
      },
      set(v) {
        this.templateAnswerText = v;
      },
    },
    ucceEnabled() {
      return this.ucceIntegration;
    },
    miniMode() {
      return this.mode === 'MINI' && this.isFrame && !this.ucceEnabled;
    },
    buttonSize() {
      return this.miniMode ? 'middle' : 'large';
    },
    currentActivity() {
      return this.getActivityById(this.value.activityId);
    },
  },
  watch: {
    templateAnswerSelect(v) {
      this.templateAnswerTextEditor = v;
    },
  },
};
</script>

<template lang="pug">
div(:class="[$style.root, miniMode && $style.rootMini]")
  header(:class="$style.header")
    div(:class="$style.headerTitle", data-test="TEMPLATE_LIST") {{ $t('T_ANSWER_TEMPLATES') }}
  div(:class="[$style.content, miniMode && $style.contentMini]")
    v-select(:items="defaultAnswerTemplates", v-model="templateAnswerSelect",
      :menu-props="{ zIndex: 10009 }"
      data-test="CHOOSE_TEMPLATE", :label="$t('T_SELECT_TEMPLATE')")
    v-textarea(name="input", data-test="INPUT_TEMPLATE", v-model="templateAnswerTextEditor",
      :label="$t('T_TEXT_TEMPLATE')")
  div(:class="$style.action", date-test="REPLY_BUTTON")
    ui-button(colored="green", @click.native="resolve(true)",
      @keyup.enter.native="resolve(true)",
      :size="buttonSize",
      :disabled="!templateAnswerTextEditor || templateAnswerTextEditor.length == 0") {{ $t('T_ANSWER') }}
    ui-button(:class="$style.cancel", colored="red", @click.native="resolve(false)",
      @keyup.enter.native="resolve(false)" :size="buttonSize") {{ $t('T_CANCEL') }}
</template>

<style lang="sass" module>
.root
  display: block
  &Mini
    width: 330px
.header
  padding: 24px
  border-bottom: 1px solid $color_divider
  &Title
    font-size: 18px
    display: flex
    justify-content: center
.content
  display: flex
  flex-direction: column
  padding: 24px
  min-width: 532px
  height: 303px
  flex: 1 1 100%
  &Mini
    height: 270px
    min-width: 320px
.action
  display: flex
  padding: 24px
  justify-content: space-around
.cancel
  margin-left: 16px

</style>
